module.exports = __webpack_public_path__ + "img/Icon_Investigation.3b94d358.svg";